import { Banknote, CalendarDays, ChevronLeft, MapPin } from "lucide-react";
import { useState } from "react";
import SkillsAndExperience from "./sections/SkillsAndExperience/SkillsAndExperience";
import JobDetails from "./sections/JobDetails/JobDetails";
import Tracker from "./sections/Tracker/Tracker";

const tabs = [
  {
    label: "Overview",
    value: "overview",
  },
  {
    label: "Tracker",
    value: "tracker",
  },
  {
    label: "Messages",
    value: "messages",
  },
  {
    label: "Job Details",
    value: "job-details",
  },
  {
    label: "Skills & Experience",
    value: "skills-and-experience",
  },
];

const RenderBody = ({ activeTab }) => {
  switch (activeTab) {
    case "overview":
      return <SkillsAndExperience />;
    case "tracker":
      return <Tracker />;
    case "job-details":
      return <JobDetails />;

    default:
      return <SkillsAndExperience />;
  }
};

const AppliedJobDetailsNew = () => {
  const [activeTab, setActiveTab] = useState("tracker");

  return (
    <div className="flex flex-col flex-1 min-w-0 rounded-md bg-white p-4 gap-3 min-h-0 overflow-y-scroll no-scrollbar">
      <button className="flex items-center font-semibold text-xs text-charcoal">
        <ChevronLeft size={16} />
        Back to Applied Jobs
      </button>

      {/* Top header */}
      <div className="flex items-center rounded-md border px-4 pt-4">
        <div className="flex flex-col gap-6">
          <div className="flex gap-5">
            <div className="flex justify-center items-center bg-charcoal h-14 w-14 rounded-md">
              <span className="text-white font-bold text-4xl">A</span>
            </div>

            <div className="flex flex-col gap-1">
              <span className="font-semibold">Mid Level React Developer</span>
              <span className="font-semibold text-xs">Cybersecure Ltd</span>
              <div className="flex items-center text-primary text-xss font-semibold gap-5">
                <div className="flex items-center gap-1.5">
                  <MapPin size={14} />
                  <span>London, UK</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <CalendarDays size={14} />
                  <span>Full Time</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <Banknote size={14} />
                  <span>60,000 - 80,000</span>
                </div>
              </div>
            </div>
          </div>
          {/* Tabs container */}
          <div className="flex gap-12">
            {tabs?.map((tab) => {
              const isActive = tab?.value === activeTab;
              return (
                <button
                  onClick={() => setActiveTab(tab?.value)}
                  className={`flex flex-col font-semibold text-xs text-primary gap-2.5 `}
                >
                  {tab?.label}
                  <div
                    className={`h-[3px] w-full rounded-t ${isActive ? "bg-primary" : "bg-transparent"}`}
                  ></div>
                </button>
              );
            })}
          </div>
        </div>
        <div></div>
      </div>

      {/* Main container */}
      <div className="flex flex-col flex-1 min-h-0 overflow-y-scroll no-scrollbar">
        <RenderBody activeTab={activeTab} />
      </div>
    </div>
  );
};

export default AppliedJobDetailsNew;
